import { motion } from 'framer-motion';
import { Button } from '../Button';

export function StepSuccess({ summary }) {
  return (
    <div className="booking-step booking-success">
      <motion.div
        className="booking-success__badge"
        initial={{ scale: 0.6, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 220, damping: 16 }}
        aria-hidden="true"
      >
        ✓
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.15, duration: 0.45 }}
      >
        <p className="eyebrow">Step 5</p>
        <h3>Consultation Request Received</h3>
        <p>
          Thanks{summary?.name ? `, ${summary.name}` : ''}. Your booking draft is ready for backend
          confirmation. We will reach out on {summary?.preferredCommunication || 'your preferred channel'} soon.
        </p>
      </motion.div>

      <motion.div
        className="booking-success__actions"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.28, duration: 0.4 }}
      >
        <Button to="/">Back to Home</Button>
        <Button to="/portfolio" variant="secondary">
          View Work
        </Button>
      </motion.div>
    </div>
  );
}
